(() => {
  const init=()=>{
    const home=document.querySelector('artmotri-home.am-home-editorial');
    const header=document.getElementById('header-component');
    if(!home||!header||home.hasAttribute('data-am-editorial-header-ready'))return;
    home.setAttribute('data-am-editorial-header-ready','');
    const entrance=home.querySelector('.am-entrance');
    const signature=home.querySelector('.am-entrance-signature');
    if(!entrance||!signature)return;
    const controls=[header.querySelector('.header-logo'),header.querySelector('header-actions')].filter(Boolean);
    const mobile=window.matchMedia('(max-width:749px)');
    const drawer=header.querySelector('#Details-menu-drawer-container');
    let frame=0,headerHeight=0;
    const measure=()=>{
      headerHeight=header.getBoundingClientRect().height;
    };
    const update=()=>{
      frame=0;
      const drawerOpen=!!drawer?.open;
      const navOpen=drawerOpen||!!header.querySelector('.menu-list__trigger [aria-expanded="true"],header-menu details[open]');
      const shown=!mobile.matches||drawerOpen||signature.getBoundingClientRect().bottom<=0;
      const solid=navOpen||entrance.getBoundingClientRect().bottom<=headerHeight+(mobile.matches?96:160);
      document.body.classList.toggle('am-home-header-solid',solid);
      document.body.classList.toggle('am-home-native-menu-open',drawerOpen);
      header.classList.toggle('am-home-controls-visible',shown);
      header.style.setProperty('--am-home-controls-opacity',shown?'1':'0');
      header.style.setProperty('--am-home-controls-offset',shown?'0px':'6px');
      controls.forEach(control=>{
        control.inert=!shown;
        if(shown)control.removeAttribute('aria-hidden');
        else control.setAttribute('aria-hidden','true');
      });
    };
    const queue=()=>{if(!frame)frame=requestAnimationFrame(update);};
    const refresh=()=>{measure();queue();};
    document.body.classList.add('am-editorial-home');
    measure();
    update();
    document.documentElement.classList.add('am-native-home-header-ready');
    document.documentElement.classList.remove('am-native-home-header-pending');
    window.addEventListener('scroll',queue,{passive:true,capture:true});
    window.addEventListener('resize',refresh,{passive:true});
    window.addEventListener('pageshow',refresh);
    mobile.addEventListener('change',refresh);
    const observer=new MutationObserver(queue);
    observer.observe(header,{subtree:true,attributes:true,attributeFilter:['open','aria-expanded']});
    document.addEventListener('shopify:section:unload',event=>{
      if(!event.target.contains(home)&&!event.target.contains(header))return;
      window.removeEventListener('scroll',queue,true);
      window.removeEventListener('resize',refresh);
      window.removeEventListener('pageshow',refresh);
      mobile.removeEventListener('change',refresh);
      observer.disconnect();
      if(frame)cancelAnimationFrame(frame);
      document.body.classList.remove('am-editorial-home','am-home-header-solid','am-home-native-menu-open');
      document.documentElement.classList.remove('am-native-home-header-ready');
    },{once:true});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  document.addEventListener('shopify:section:load',init);
})();
